import { CustomEventType } from '@/features/types'

export const handleOpenCartLimit = () => {
    const openEvent = new CustomEvent(CustomEventType.CartLimit, {
        bubbles: true,
    })

    document.dispatchEvent(openEvent)
}
